// =============================================================================
// src/views/workspace/workspace-seed.ts — Dados-semente do Workspace (mockados).
//
// Os 4 cards do mockup original (unified.html) transcritos VERBATIM + 4 extras,
//   de modo que cada bucket da nav (mine/shared/team/favoritos), cada tag e as 8
//   seções scrolláveis fiquem demonstráveis. `createdAtMs` são epochs fixos (não
//   Date.now) para ordenação determinística em teste. Repovoado pelo store quando
//   o localStorage está vazio/inválido ou via "Restaurar exemplos".
//
// SRP: só constante de dados. Zero DOM, zero lógica.
// =============================================================================

import type { WorkspaceAnalysis } from './workspace-types';

/** Quantidade de itens mostrados pela categoria "Recentes" (top-N por recência). */
export const WORKSPACE_RECENT_COUNT = 5;

/** Atividade rica do card 1 (preserva o feed default do painel legado). */
const ZONA_NORTE_ACTIVITY = [
  { actor: 'TS comentou', detail: '"ver abstenção bairro Aleixo" · 2h' },
  { actor: 'MR editou camada', detail: 'Vulnerabilidade social · ontem' },
  { actor: 'TS exportou PDF', detail: 'Relatório completo · 3 dias' },
  { actor: 'Análise criada', detail: 'por TS · 15 out 2024' },
] as const;

/** ~8 análises-semente. Ordem de recência decresce de extra→verbatim (createdAtMs). */
export const WORKSPACE_SEED_ANALYSES: readonly WorkspaceAnalysis[] = [
  {
    id: 'ws-seed-1',
    title: 'Zona Norte — Cenário pós-campanha',
    meta: 'Atualizado 2h atrás · 3 camadas',
    share: 'Compartilhado com 4 pessoas',
    created: '15 out 2024',
    layers: '3 ativas',
    views: '47×',
    viewsCount: 47,
    tags: ['eleição', 'zona norte'],
    favorite: true,
    category: 'shared',
    createdAtMs: 1728950400000,
    targetSection: 'mapa-eleitoral',
    zona: 'norte',
    activity: ZONA_NORTE_ACTIVITY,
  },
  {
    id: 'ws-seed-2',
    title: 'Comparativo 2020 × 2024 — PL',
    meta: 'Atualizado ontem · compartilhado',
    share: 'Compartilhado com bancada regional',
    created: '03 nov 2024',
    layers: '2 camadas',
    views: '31×',
    viewsCount: 31,
    tags: ['2024'],
    favorite: false,
    category: 'shared',
    createdAtMs: 1730592000000,
    targetSection: 'comparador',
    activity: [{ actor: 'MR editou camada', detail: 'Comparativo PL · ontem' }],
  },
  {
    id: 'ws-seed-3',
    title: 'Segmento evangélico × voto PL',
    meta: 'Atualizado 3 dias · 2 camadas',
    share: 'Privado',
    created: '08 nov 2024',
    layers: '2 ativas',
    views: '18×',
    viewsCount: 18,
    tags: ['rascunho'],
    favorite: false,
    category: 'mine',
    createdAtMs: 1731024000000,
    targetSection: 'demografica',
    activity: [{ actor: 'Análise criada', detail: 'por você · 08 nov 2024' }],
  },
  {
    id: 'ws-seed-4',
    title: 'Fiscal gap — Zonas Norte & Oeste',
    meta: 'Atualizado semana passada · urgente',
    share: 'Compartilhado com coordenação',
    created: '28 out 2024',
    layers: '4 ativas',
    views: '64×',
    viewsCount: 64,
    tags: ['urgente'],
    favorite: false,
    category: 'team',
    createdAtMs: 1730073600000,
    targetSection: 'impostometro',
    zona: 'oeste',
    activity: [{ actor: 'TS exportou PDF', detail: 'Gap fiscal · semana passada' }],
  },
  {
    id: 'ws-seed-5',
    title: 'Mobilização Zona Leste — porta a porta',
    meta: 'Atualizado hoje · 1 camada',
    share: 'Privado',
    created: '20 nov 2024',
    layers: '1 ativa',
    views: '12×',
    viewsCount: 12,
    tags: ['eleição'],
    favorite: true,
    category: 'mine',
    createdAtMs: 1732060800000,
    targetSection: 'monitoramento',
    zona: 'leste',
    activity: [{ actor: 'Análise criada', detail: 'por você · hoje' }],
  },
  {
    id: 'ws-seed-6',
    title: 'Bancada evangélica — engajamento de campo',
    meta: 'Atualizado 8 dias · 3 camadas',
    share: 'Compartilhado com o time de campo',
    created: '12 nov 2024',
    layers: '3 ativas',
    views: '88×',
    viewsCount: 88,
    tags: ['2024'],
    favorite: false,
    category: 'team',
    createdAtMs: 1731369600000,
    targetSection: 'negocios',
    activity: [{ actor: 'MR comentou', detail: '"reforçar igrejas zona norte" · 8 dias' }],
  },
  {
    id: 'ws-seed-7',
    title: 'Mapa de calor — abstenção 2022',
    meta: 'Atualizado 19 dias · 2 camadas',
    share: 'Privado',
    created: '01 nov 2024',
    layers: '2 ativas',
    views: '5×',
    viewsCount: 5,
    tags: ['rascunho'],
    favorite: false,
    category: 'mine',
    createdAtMs: 1730419200000,
    targetSection: 'camadas',
    zona: 'centro-sul',
    activity: [{ actor: 'Análise criada', detail: 'por você · 01 nov 2024' }],
  },
  {
    id: 'ws-seed-8',
    title: 'Perfil socioeconômico — Zona Sul',
    meta: 'Atualizado 2 dias · 2 camadas',
    share: 'Compartilhado com 2 pessoas',
    created: '18 nov 2024',
    layers: '2 ativas',
    views: '53×',
    viewsCount: 53,
    tags: ['urgente'],
    favorite: true,
    category: 'shared',
    createdAtMs: 1731888000000,
    targetSection: 'perfil-regiao',
    zona: 'sul',
    activity: [{ actor: 'TS editou camada', detail: 'Renda média · 2 dias' }],
  },
];
